import React, { createContext, useState } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("Türkçe");

  const chooseLanguage = (dil) => {
    setLanguage(dil);
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        chooseLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
